const mrpSwitchesDefault = {
  attack: true,
  catastrophe: true,
  tech_catastrophe: true,
  neighboring_third_party_recourses: true,
  additional_costs: true,
  VTAM_choc_provisioire: true,
  operation_of_premises: true,
  intoxication_alimentaire: true,
  owner_insurance: false,
  exploitation_loss: false,
  tenant_responsibility: true,
  neighbours_appeal: true,
  tenant_appeal: true,
  lawsuit_defense: true,
  social_mandate_responsibility: false,
  extended_legal_protection_mrp: false,
  legal_protection_mrp: true,
  assistance: false,
  archives_capital: false,
  value_capital: false,
  art_capital: false,
  theft_capital: false,
  lent_goods: false
};

export { mrpSwitchesDefault };
